/* DEPARTMENT */
export const TIMESHEET_LIST = 'TIMESHEET_LIST';
export const TIMESHEET_LIST_SUCCESS = 'TIMESHEET_LIST_SUCCESS';
export const TIMESHEET_LIST_FAILED = 'TIMESHEET_LIST_FAILED';

export const TIMESHEET_PUNCHIN = 'TIMESHEET_PUNCHIN';
export const TIMESHEET_PUNCHIN_SUCCESS = 'TIMESHEET_PUNCHIN_SUCCESS';
export const TIMESHEET_PUNCHIN_FAILED = 'TIMESHEET_PUNCHIN_FAILED';

export const TIMESHEET_BREAK = 'TIMESHEET_BREAK';
export const TIMESHEET_BREAK_SUCCESS = 'TIMESHEET_BREAK_SUCCESS';
export const TIMESHEET_BREAK_FAILED = 'TIMESHEET_BREAK_FAILED';

export const TIMESHEET_PUNCHOUT = 'TIMESHEET_PUNCHOUT';
export const TIMESHEET_PUNCHOUT_SUCCESS = 'TIMESHEET_PUNCHOUT_SUCCESS';
export const TIMESHEET_PUNCHOUT_FAILED = 'TIMESHEET_PUNCHOUT_FAILED';


export const DESKSHOT_ADD = 'DESKSHOT_ADD';
export const DESKSHOT_ADD_SUCCESS = 'DESKSHOT_ADD_SUCCESS';
export const DESKSHOT_ADD_FAILED = 'DESKSHOT_ADD_FAILED';
